




import {Vue, Component} from 'vue-property-decorator'

import BroadcastHistory  from '@/components/BroadcastHistory.vue'

@Component({
  components: {
      BroadcastHistory
  }
})
export default class BroadcastHistoryView extends Vue {
}
